/* Vitafant Summer Sale – Gift-Guard
   Entfernt die Gratis-Strandtasche automatisch aus dem Warenkorb, wenn die
   Qualifikation wegfällt (kein 6er-Pulver-Set / kein 2×+ Routine-Set mehr),
   und begrenzt die Gift-Line auf 1 Stück. Greift NUR Lines mit dem Property
   `_summersale_gift` an – regulär gekaufte Taschen bleiben unberührt.
   Einbindung: in der LP-Section (automatisch) UND in theme.liquid vor </body>:
     <script src="{{ 'vf-ss-gift-guard.js' | asset_url }}" defer></script>
   Nach dem Sale kann die Zeile entfernt werden (Script ist ohne Gift-Line inert). */
(function () {
  if (window.__vfGiftGuard) return;
  window.__vfGiftGuard = true;

  var SEv = null, ThemeEv = null;
  try {
    import('@shopify/events').then(function (m) {
      SEv = m;
      if (m.StandardEvents && m.StandardEvents.cartLinesUpdate) {
        document.addEventListener(m.StandardEvents.cartLinesUpdate, onThemeCartEvent);
      }
    }).catch(function () {});
  } catch (e) {}
  try { import('@theme/events').then(function (m) { ThemeEv = m; }).catch(function () {}); } catch (e) {}

  /* Die Geschenk-Line wird ausschliesslich am Property `_summersale_gift` erkannt –
     damit funktioniert der Guard mit jedem Geschenk der Backup-Kette, ohne dass
     hier Handles gepflegt werden muessen. Regulaer gekaufte Exemplare tragen das
     Property nicht und bleiben unberuehrt. */
  var POWDER_HANDLES = ["grune-helfer", "lila-leben", "rosa-glanz"];
  var ROUTINE_HANDLE = "routine-bundle";
  var busy = false;

  function qualifies(items) {
    return items.some(function (i) {
      var p = i.properties || {};
      if (p._summersale !== "1") return false;
      if (POWDER_HANDLES.indexOf(i.handle) > -1) return i.quantity >= 6;
      if (i.handle === ROUTINE_HANDLE) return i.quantity >= 2;
      return false;
    });
  }

  function refreshSections() {
    var secs = Array.prototype.slice.call(document.querySelectorAll('[id^="shopify-section-"]'))
      .map(function (el) { return el.id.replace("shopify-section-", ""); })
      .filter(function (id) { return /cart|header/i.test(id); });
    if (!secs.length) {
      if (location.pathname.indexOf("/cart") === 0) location.reload();
      return;
    }
    fetch(location.pathname + "?sections=" + encodeURIComponent(secs.join(",")), {
      headers: { Accept: "application/json" }
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        secs.forEach(function (id) {
          if (!data[id]) return;
          var host = document.getElementById("shopify-section-" + id);
          if (!host) return;
          var tmp = document.createElement("div");
          tmp.innerHTML = data[id];
          var fresh = tmp.firstElementChild;
          host.innerHTML = fresh && fresh.id === host.id ? fresh.innerHTML : data[id];
        });
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      })
      .catch(function () {});
  }


  function lockLpQuantities(cart) {
    var apply = function (ajaxCart) {
      document.querySelectorAll("cart-items-component").forEach(function (comp) {
        var rows = comp.querySelectorAll('[ref="cartItemRows[]"]');
        ajaxCart.items.forEach(function (it, idx) {
          var p = it.properties || {};
          if (p._summersale !== "1" && p._summersale_gift !== "1") return;
          var row = rows[idx];
          if (!row || row.getAttribute("data-vf-locked") === "1") return;
          row.querySelectorAll(
            "cart-quantity-selector-component button, cart-quantity-selector-component input, " +
            "quantity-selector-component button, quantity-selector-component input"
          ).forEach(function (el) {
            if (el.tagName === "BUTTON") {
              el.disabled = true;
              el.setAttribute("aria-disabled", "true");
              el.style.opacity = ".35";
              el.style.pointerEvents = "none";
            } else {
              el.readOnly = true;
              el.style.pointerEvents = "none";
            }
          });
          row.setAttribute("data-vf-locked", "1");
        });
      });
    };
    if (cart) { apply(cart); return; }
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {});
  }

  /* Morphs/Swaps der Cart-Liste abfangen und Sperren erneut anwenden */
  var lockTimer = null;
  new MutationObserver(function () {
    clearTimeout(lockTimer);
    lockTimer = setTimeout(function () { lockLpQuantities(); }, 120);
  }).observe(document.body, { childList: true, subtree: true });

  var enforceTimer = null;
  function scheduleEnforce(delay) {
    clearTimeout(enforceTimer);
    enforceTimer = setTimeout(enforce, delay || 120);
  }

  function enforce() {
    if (busy) return;
    busy = true;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gift = null;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.properties && it.properties._summersale_gift === "1") {
            gift = it;
            break;
          }
        }
        lockLpQuantities(cart);
        var ok = qualifies(cart.items);
        if (!gift) { busy = false; return; }
        if (ok && gift.quantity === 1) { busy = false; return; }

        function compSectionId(el) {
          if (el.dataset && el.dataset.sectionId) return el.dataset.sectionId;
          var w = el.closest && el.closest('[id^="shopify-section-"]');
          return w ? w.id.replace("shopify-section-", "") : null;
        }
        var secIds = [];
        document.querySelectorAll("cart-items-component").forEach(function (el) {
          var id = compSectionId(el);
          if (id && secIds.indexOf(id) < 0) secIds.push(id);
        });

        /* /cart/change.js akzeptiert den Line-Key als id (update.js kann nur Variant-IDs) */
        var body = { id: gift.key, quantity: ok ? 1 : 0 };
        if (secIds.length) {
          body.sections = secIds.join(",");
          body.sections_url = window.location.pathname;
        }

        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
          .then(function (updResp) {
            busy = false;
            return fetch("/cart.js", { headers: { Accept: "application/json" } })
              .then(function (r) { return r.json(); })
              .then(function (ajaxCart) {
                var sections = (updResp && updResp.sections) || {};
                var missing = secIds.filter(function (id) { return !sections[id]; });
                var fill = missing.length
                  ? fetch(window.location.pathname + "?sections=" + encodeURIComponent(missing.join(",")), {
                      headers: { Accept: "application/json" }
                    }).then(function (r) { return r.json(); })
                      .then(function (extra) {
                        missing.forEach(function (id) { if (extra[id]) sections[id] = extra[id]; });
                      }).catch(function () {})
                  : Promise.resolve();
                return fill.then(function () { return { ajaxCart: ajaxCart, sections: sections }; });
              })
              .then(function (res) {
                var ajaxCart = res.ajaxCart, sections = res.sections;

                /* Cart-Liste direkt austauschen – unabhängig vom Theme-Handler.
                   Ersetzt nur die cart-items-component, der Drawer bleibt offen. */
                var swapped = 0;
                secIds.forEach(function (id) {
                  if (!sections[id]) return;
                  var tmp = document.createElement("div");
                  tmp.innerHTML = sections[id];
                  var fresh = tmp.querySelector("cart-items-component");
                  if (!fresh) return;
                  document.querySelectorAll("cart-items-component").forEach(function (cur) {
                    if (compSectionId(cur) === id) {
                      cur.replaceWith(fresh.cloneNode(true));
                      swapped++;
                    }
                  });
                });

                if (ThemeEv && ThemeEv.CartUpdateEvent) {
                  document.dispatchEvent(new ThemeEv.CartUpdateEvent(ajaxCart, "vf-gift-guard", {
                    source: "cart-items-component",
                    itemCount: ajaxCart.item_count,
                    sections: sections,
                    didError: false
                  }));
                  return;
                }
                if (SEv && SEv.CartLinesUpdateEvent) {
                  var d = SEv.CartLinesUpdateEvent.createPromise();
                  document.dispatchEvent(new SEv.CartLinesUpdateEvent({
                    action: "update", context: "product", lines: [], promise: d.promise
                  }));
                  d.resolve({
                    cart: SEv.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
                    detail: {
                      items: ajaxCart.items, source: "product-form-component", sourceId: "vf-gift-guard",
                      itemCount: ajaxCart.item_count, productId: "", sections: sections, didError: false
                    }
                  });
                  return;
                }
                refreshSections();
              });
          })
          .catch(function (err) {
            busy = false;
            if (err && err.status === "bad_request") {
              return;
            }
            console.warn("[vf-gift-guard] Entfernen fehlgeschlagen:", err);
          });
      })
      .catch(function (err) { busy = false; console.warn("[vf-gift-guard] Cart-Check fehlgeschlagen:", err); });
  }

  /* Primärer Trigger: das Theme dispatcht nach jeder Cart-Änderung `cart:update`
     (Horizon 3.x). Eigene Guard-Events werden über sourceId übersprungen. */
  function onThemeCartEvent(e) {
    if (busy) return;
    var d = e && e.detail;
    if (d && d.sourceId === "vf-gift-guard") return;
    scheduleEnforce(80);
  }
  document.addEventListener("cart:update", onThemeCartEvent);

  /* Netz für Flows ohne Theme-Event: Cart-Mutationen via fetch abfangen */
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url) && !busy) {
      p.then(function () { scheduleEnforce(120); }, function () {});
    }
    return p;
  };

  lockLpQuantities();
  enforce();
})();